// src/api/index.ts
import { initTsrReactQuery } from "@ts-rest/react-query/v5";
import { rootHttpContract } from "@flote/contracts/http";
import { QueryClient } from "@tanstack/react-query";
var tokenGetter = () => null;
var currentConfig = {
  baseUrl: "http://localhost:4000",
  getToken: () => null,
  appSource: "flote-app"
};
function createClient(config) {
  return initTsrReactQuery(rootHttpContract, {
    baseUrl: config.baseUrl,
    baseHeaders: {
      "Content-Type": "application/json",
      "x-app-source": config.appSource ?? "flote-app",
      Authorization: () => {
        const token = tokenGetter();
        return token ? `Bearer ${token}` : "";
      }
    }
  });
}
var tsr = createClient(currentConfig);
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 1e3,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error && typeof error === "object" && "response" in error) {
          const errorWithResponse = error;
          if (errorWithResponse.response?.status === 401) {
            return false;
          }
        }
        return failureCount < 3;
      }
    },
    mutations: {
      retry: false
    }
  }
});
function initializeApiClient(config) {
  currentConfig = config;
  tokenGetter = config.getToken;
  tsr = createClient(config);
}

export {
  rootHttpContract,
  tsr,
  queryClient,
  initializeApiClient
};
